webpackJsonp([1],{

/***/ "+ZBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'interactives-check-input',
  props: ['inputData'],
  data: function data() {
    return {
      value: []
    };
  },

  watch: {
    value: function value(newValue) {
      this.inputData.value = newValue;
    }
  }
});

/***/ }),

/***/ "+iTR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/JoN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_TextInput_vue__ = __webpack_require__("IKj0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cf95f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_TextInput_vue__ = __webpack_require__("rNIx");
function injectStyle (ssrContext) {
  __webpack_require__("Ju31")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_TextInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cf95f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_TextInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/pH/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'interactives-will-output',
  props: ['formData', 'templateData'],
  methods: {
    selected: function selected(string) {
      return __WEBPACK_IMPORTED_MODULE_0_jquery__["inArray"](string, this.formData[0].value) > -1;
    },
    print: function print() {
      var content = __WEBPACK_IMPORTED_MODULE_0_jquery__('.will-output-body').html();
      var mywindow = window.open('', 'Print', 'height=600,width=800');

      mywindow.document.write('<html><head><title>Digital Will</title>');
      mywindow.document.write('</head><body >');
      mywindow.document.write(content);
      mywindow.document.write('</body></html>');

      mywindow.document.close();
      mywindow.focus();
      mywindow.print();
      mywindow.close();
      return true;
    }
  }
});

/***/ }),

/***/ "0inR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interactives_input_src_App_vue__ = __webpack_require__("l0+4");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'interactives-will-input',
  props: ['formData', 'templateData'],
  components: {
    'custom-input': __WEBPACK_IMPORTED_MODULE_1__interactives_input_src_App_vue__["a" /* default */]
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_jquery__('input[placeholder]').each(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery__(this).attr('size', __WEBPACK_IMPORTED_MODULE_0_jquery__(this).attr('placeholder').length);
    });
  },

  methods: {
    selected: function selected(string) {
      return __WEBPACK_IMPORTED_MODULE_0_jquery__["inArray"](string, this.formData[0].value) > -1;
    }
  }
});

/***/ }),

/***/ "34kq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactives-will-input"},[_c('button',{staticClass:"back-button",on:{"click":function($event){_vm.$emit('back')}}},[_vm._v("« Back")]),_vm._v(" "),_c('div',{staticClass:"will-input-body"},[_vm._m(0,false,false),_vm._v(" "),_c('p',[_vm._v("\n          I, "),_c('custom-input',{attrs:{"inputData":_vm.templateData.userName},model:{value:(_vm.templateData.userName.value),callback:function ($$v) {_vm.$set(_vm.templateData.userName, "value", $$v)},expression:"templateData.userName.value"}}),_vm._v(" of "),_c('custom-input',{attrs:{"inputData":_vm.templateData.userResidence},model:{value:(_vm.templateData.userResidence.value),callback:function ($$v) {_vm.$set(_vm.templateData.userResidence, "value", $$v)},expression:"templateData.userResidence.value"}}),_vm._v(", establish this as my digital will, laying out my preferences for the future use of my online accounts.\n      ")],1),_vm._v(" "),_c('p',[_vm._v("\n          I appoint "),_c('custom-input',{attrs:{"inputData":_vm.templateData.execName},model:{value:(_vm.templateData.execName.value),callback:function ($$v) {_vm.$set(_vm.templateData.execName, "value", $$v)},expression:"templateData.execName.value"}}),_vm._v(" of "),_c('custom-input',{attrs:{"inputData":_vm.templateData.execResidence},model:{value:(_vm.templateData.execResidence.value),callback:function ($$v) {_vm.$set(_vm.templateData.execResidence, "value", $$v)},expression:"templateData.execResidence.value"}}),_vm._v(" as the sole executor of this will.\n      ")],1),_vm._v(" "),_c('p',[_vm._v("\n          Where appropriate and necessary, passwords and other login credentials will be provided to my executor via separate documentation.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n          I give my executor the following duties and responsibilities:\n      ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formData[2].value),expression:"formData[2].value"}]},[_c('h3',[_vm._v("\n              Web browsing history\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n              Delete the entire browsing history from all browsers on my computer.\n          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected('Email')),expression:"selected('Email')"}]},[_c('h3',[_vm._v("\n              Email\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n              I employ "),_c('custom-input',{attrs:{"inputData":_vm.templateData.email[0]},model:{value:(_vm.templateData.email[0].value),callback:function ($$v) {_vm.$set(_vm.templateData.email[0], "value", $$v)},expression:"templateData.email[0].value"}}),_vm._v(". Within 30 days of my death, I request that my executor access that account using the login credentials provided via supplementary documentation. They should then:\n              ")],1),_c('div',[_c('custom-input',{attrs:{"inputData":_vm.templateData.email[1]},model:{value:(_vm.templateData.email[1].value),callback:function ($$v) {_vm.$set(_vm.templateData.email[1], "value", $$v)},expression:"templateData.email[1].value"}})],1),_vm._v(" "),_c('p')]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected('Facebook')),expression:"selected('Facebook')"}]},[_c('h3',[_vm._v("\n              Facebook\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n              I maintain a Facebook account under "),_c('custom-input',{attrs:{"inputData":_vm.templateData.facebook[0]},model:{value:(_vm.templateData.facebook[0].value),callback:function ($$v) {_vm.$set(_vm.templateData.facebook[0], "value", $$v)},expression:"templateData.facebook[0].value"}}),_vm._v(". Within 30 days of my death, I request that my executor "),_c('custom-input',{attrs:{"inputData":_vm.templateData.facebook[1]},model:{value:(_vm.templateData.facebook[1].value),callback:function ($$v) {_vm.$set(_vm.templateData.facebook[1], "value", $$v)},expression:"templateData.facebook[1].value"}}),_vm._v(".\n          ")],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected('Twitter')),expression:"selected('Twitter')"}]},[_c('h3',[_vm._v("\n              Twitter\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n              I maintain a Twitter account under\n              "),_c('custom-input',{attrs:{"inputData":_vm.templateData.twitter[0]},model:{value:(_vm.templateData.twitter[0].value),callback:function ($$v) {_vm.$set(_vm.templateData.twitter[0], "value", $$v)},expression:"templateData.twitter[0].value"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.templateData.twitter[0].value == 'the handle'),expression:"templateData.twitter[0].value == 'the handle'"}]},[_vm._v(" \n                  @"),_c('custom-input',{attrs:{"inputData":_vm.templateData.twitter[1]},model:{value:(_vm.templateData.twitter[1].value),callback:function ($$v) {_vm.$set(_vm.templateData.twitter[1], "value", $$v)},expression:"templateData.twitter[1].value"}})],1),_vm._v("\n              . Within 30 days of my death, I request that my executor \n              "),_c('custom-input',{attrs:{"inputData":_vm.templateData.twitter[2]},model:{value:(_vm.templateData.twitter[2].value),callback:function ($$v) {_vm.$set(_vm.templateData.twitter[2], "value", $$v)},expression:"templateData.twitter[2].value"}}),_vm._v(".\n          ")],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected('Amazon')),expression:"selected('Amazon')"}]},[_c('h3',[_vm._v("\n              Amazon\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n              I maintain an Amazon account under "),_c('custom-input',{attrs:{"inputData":_vm.templateData.amazon[0]},model:{value:(_vm.templateData.amazon[0].value),callback:function ($$v) {_vm.$set(_vm.templateData.amazon[0], "value", $$v)},expression:"templateData.amazon[0].value"}}),_vm._v(". Where allowed, I grant and transfer ongoing ownership of all e-books, digital movies, and music associated with that account to "),_c('custom-input',{attrs:{"inputData":_vm.templateData.amazon[1]},model:{value:(_vm.templateData.amazon[1].value),callback:function ($$v) {_vm.$set(_vm.templateData.amazon[1], "value", $$v)},expression:"templateData.amazon[1].value"}}),_vm._v(". In addition, I request that my executor access my account and:\n              ")],1),_c('div',[_c('custom-input',{attrs:{"inputData":_vm.templateData.amazon[2]},model:{value:(_vm.templateData.amazon[2].value),callback:function ($$v) {_vm.$set(_vm.templateData.amazon[2], "value", $$v)},expression:"templateData.amazon[2].value"}})],1),_vm._v(" "),_c('p')]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected('iTunes')),expression:"selected('iTunes')"}]},[_c('h3',[_vm._v("\n              iTunes\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n              I maintain an iTunes account under "),_c('custom-input',{attrs:{"inputData":_vm.templateData.itunes[0]},model:{value:(_vm.templateData.itunes[0].value),callback:function ($$v) {_vm.$set(_vm.templateData.itunes[0], "value", $$v)},expression:"templateData.itunes[0].value"}}),_vm._v(". Where allowed, I grant and transfer ongoing ownership of all digital content associated with that account to "),_c('custom-input',{attrs:{"inputData":_vm.templateData.itunes[1]},model:{value:(_vm.templateData.itunes[1].value),callback:function ($$v) {_vm.$set(_vm.templateData.itunes[1], "value", $$v)},expression:"templateData.itunes[1].value"}}),_vm._v(".\n          ")],1)]),_vm._v(" "),_vm._l((_vm.formData[1].value),function(service,index){return _c('div',[_c('h3',[_vm._v("\n              "+_vm._s(service)+"\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n              I maintain an account with "+_vm._s(service)+" under the login "),_c('custom-input',{attrs:{"inputData":_vm.templateData.additional[service][0]},model:{value:(_vm.templateData.additional[service][0].value),callback:function ($$v) {_vm.$set(_vm.templateData.additional[service][0], "value", $$v)},expression:"templateData.additional[service][0].value"}}),_vm._v(". I request that my executor do the following with that account:\n              ")],1),_c('div',[_c('custom-input',{attrs:{"inputData":_vm.templateData.additional[service][1]},model:{value:(_vm.templateData.additional[service][1].value),callback:function ($$v) {_vm.$set(_vm.templateData.additional[service][1], "value", $$v)},expression:"templateData.additional[service][1].value"}})],1),_vm._v(" "),_c('div',[_c('p',[_c('custom-input',{attrs:{"inputData":_vm.templateData.additional[service][2]},model:{value:(_vm.templateData.additional[service][2].value),callback:function ($$v) {_vm.$set(_vm.templateData.additional[service][2], "value", $$v)},expression:"templateData.additional[service][2].value"}})],1)]),_vm._v("\n              In addition,\n              "),_c('div',[_c('custom-input',{attrs:{"inputData":_vm.templateData.additional[service][3]},model:{value:(_vm.templateData.additional[service][3].value),callback:function ($$v) {_vm.$set(_vm.templateData.additional[service][3], "value", $$v)},expression:"templateData.additional[service][3].value"}})],1),_vm._v(" "),_c('p')])})],2),_vm._v(" "),_c('div',{staticClass:"cont-btn-c"},[_c('button',{staticClass:"continue-button",on:{"click":function($event){_vm.$emit('submitForm')}}},[_vm._v("Continue")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"will-disclaimer"},[_c('em',[_vm._v("This document is "),_c('strong',[_vm._v("not legally binding or enforceable")]),_vm._v(".")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3NFN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_ListBuilder_vue__ = __webpack_require__("MXpj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_555fb632_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_ListBuilder_vue__ = __webpack_require__("tqyj");
function injectStyle (ssrContext) {
  __webpack_require__("F30d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_ListBuilder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_555fb632_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_ListBuilder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4qYl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactives-dropdown-input"},[(_vm.inputData.label)?_c('label',{attrs:{"for":_vm.inputData.name}},[_vm._v(_vm._s(_vm.inputData.label))]):_vm._e(),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"name":_vm.inputData.name},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.value=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[(_vm.inputData.placeholder)?_c('option',{attrs:{"disabled":"","value":""}},[_vm._v(_vm._s(_vm.inputData.placeholder))]):_vm._e(),_vm._v(" "),_vm._l((_vm.inputData.options),function(option){return _c('option',{domProps:{"value":option.value !== undefined ? option.value : option.label}},[_vm._v(_vm._s(option.label))])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5suk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactives-digital-will"},[_c('div',{staticClass:"will-title"},[_vm._v("Digital Will Generator")]),_vm._v(" "),_c('keep-alive',[_c(_vm.currentView,{tag:"component",attrs:{"formData":_vm.setupForm,"formValidator":_vm.formValidator,"templateData":_vm.templateForm},on:{"submitForm":_vm.formSubmitted,"back":_vm.goBack}},[_vm._v("Continue")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7rR2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("yk1D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3652d88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("4qYl");
function injectStyle (ssrContext) {
  __webpack_require__("QOr7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3652d88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9b7w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_CheckInput_vue__ = __webpack_require__("+ZBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dce4cbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_CheckInput_vue__ = __webpack_require__("WTS4");
function injectStyle (ssrContext) {
  __webpack_require__("eueh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_CheckInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dce4cbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_CheckInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9wO9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WillOutput_vue__ = __webpack_require__("/pH/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_466f15cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WillOutput_vue__ = __webpack_require__("vMcm");
function injectStyle (ssrContext) {
  __webpack_require__("VzdL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WillOutput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_466f15cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WillOutput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A9aO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'interactives-textarea-input',
  props: ['inputData'],
  data: function data() {
    return {
      value: null
    };
  },

  watch: {
    value: function value(newValue) {
      this.inputData.value = newValue;
    }
  }
});

/***/ }),

/***/ "C4Xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interactives_input_src_App_vue__ = __webpack_require__("l0+4");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'interactives-form',
  props: ['formData', 'formValidator'],
  computed: {
    valid: function valid() {
      return this.formValidator ? this.formValidator(this.formData) : true;
    }
  },
  methods: {
    submitFields: function submitFields() {
      this.$emit('submitForm', this.formData);
    }
  },
  components: {
    'custom-input': __WEBPACK_IMPORTED_MODULE_0__interactives_input_src_App_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "CWyX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_ListItem_vue__ = __webpack_require__("FCQU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_14271851_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_ListItem_vue__ = __webpack_require__("G9ae");
function injectStyle (ssrContext) {
  __webpack_require__("p9/Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_ListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_14271851_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_ListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D+Yd":
/***/ (function(module, exports) {

module.exports = {"userName":{"type":"text-input","value":null,"name":"user-name","placeholder":"your full name"},"userResidence":{"type":"text-input","value":null,"name":"user-residence","placeholder":"your place of residence"},"execName":{"type":"text-input","value":null,"name":"exec-name","placeholder":"your executor’s full name"},"execResidence":{"type":"text-input","value":null,"name":"exec-residence","placeholder":"your executor’s place of residence"},"email":[{"type":"text-input","value":null,"name":"email-service","placeholder":"your email provider (e.g., Gmail)"},{"type":"check-input","value":null,"label":"[Select all that apply:]","name":"email-request","options":[{"label":"Respond to any recent unread messages from acquaintances with news of my death."},{"label":"Unsubscribe me to any services with recurring e-payments, except if and as otherwise discussed elsewhere in this document."},{"label":"Set up an auto reply from the account informing any future interlocutors of my passing."},{"label":"Occasionally access my account to ensure no additional messages of note have accumulated."},{"label":"After completing all of the above tasks (if any), deactivate my account."}]}],"facebook":[{"type":"dropdown","value":null,"name":"facebook-name","placeholder":" ","options":[{"label":"my own name"},{"label":"a different name provided in a supplementary document"}]},{"type":"dropdown","value":null,"placeholder":" ","name":"facebook-request","options":[{"label":"permanently delete my page and all associated content"},{"label":"convert my existing page to a Facebook memorial where others may share memories of me"}]}],"twitter":[{"type":"dropdown","value":null,"placeholder":" ","options":[{"value":"the handle","label":"the handle..."},{"label":"a private handle provided in a supplementary document"}]},{"type":"text-input","value":null,"name":"twitter-handle","placeholder":"your Twitter handle"},{"type":"dropdown","value":null,"placeholder":" ","options":[{"label":"permanently delete my Twitter account and all associated content"},{"label":"post a final tweet indicating my death"},{"label":"assume control of my account and continue to use it"}]}],"amazon":[{"type":"dropdown","value":null,"placeholder":" ","options":[{"label":"my primary email address"},{"label":"a different email address provided in a supplementary document"}]},{"type":"text-input","value":null,"name":"amazon-recipient","placeholder":"the recipient’s full name"},{"type":"check-input","value":null,"label":"[Select all that apply:]","name":"amazon-request","options":[{"label":"Remove payment information from my account."},{"label":"If possible, cancel any outstanding transactions."},{"label":"Deactivate my personal Amazon store and fulfill any outstanding transactions."}]}],"itunes":[{"type":"dropdown","value":null,"placeholder":" ","options":[{"label":"my primary email address"},{"label":"a different email address provided in a supplementary document"}]},{"type":"text-input","value":null,"name":"itunes-recipient","placeholder":"the recipient’s full name"}],"additional":{}}

/***/ }),

/***/ "F30d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FCQU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'interactives-list-item',
  props: ['itemContent']
});

/***/ }),

/***/ "FEnh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactives-textarea-input"},[(_vm.inputData.label)?_c('label',{attrs:{"for":_vm.inputData.name}},[_vm._v(_vm._s(_vm.inputData.label))]):_vm._e(),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"name":_vm.inputData.name,"placeholder":_vm.inputData.placeholder},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G9ae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"interactives-list-item"},[_c('span',{staticClass:"item-content"},[_vm._v(_vm._s(_vm.itemContent))]),_vm._v(" "),_c('button',{staticClass:"item-close",on:{"click":function($event){_vm.$emit('remove')}}},[_vm._v("(Remove)")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IKj0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'interactives-text-input',
  props: ['inputData'],
  data: function data() {
    return {
      value: null
    };
  },

  watch: {
    value: function value(newValue) {
      this.inputData.value = newValue;
    }
  }
});

/***/ }),

/***/ "Ju31":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KewI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactives-input"},[_c(_vm.inputData.type,{tag:"component",attrs:{"inputData":_vm.inputData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LE1/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LvZL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_RadioInput_vue__ = __webpack_require__("VSv+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c04a5cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_RadioInput_vue__ = __webpack_require__("cDoD");
function injectStyle (ssrContext) {
  __webpack_require__("+iTR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_RadioInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c04a5cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_RadioInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26d61372_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("5suk");
function injectStyle (ssrContext) {
  __webpack_require__("LE1/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26d61372_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MXpj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItem_vue__ = __webpack_require__("CWyX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'interactives-check-input',
  props: ['inputData'],
  data: function data() {
    return {
      newListItem: '',
      nextItemId: this.inputData.value.length,
      listItems: this.inputData.value.slice(0)
    };
  },

  components: {
    'list-item': __WEBPACK_IMPORTED_MODULE_0__ListItem_vue__["a" /* default */]
  },
  methods: {
    addNewListItem: function addNewListItem() {
      this.listItems.push({
        id: this.nextItemId++,
        content: this.newListItem
      });
      this.inputData.value.push(this.newListItem);
      this.newListItem = '';
    },
    removeListItem: function removeListItem(index) {
      this.listItems.splice(index, 1);
      this.inputData.value.splice(index, 1);
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '.interactives-digital-will',
  template: '<DigitalWill/>',
  components: { DigitalWill: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OH0K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TextInput__ = __webpack_require__("/JoN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TextareaInput__ = __webpack_require__("iH6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dropdown__ = __webpack_require__("7rR2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CheckInput__ = __webpack_require__("9b7w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_RadioInput__ = __webpack_require__("LvZL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ListBuilder__ = __webpack_require__("3NFN");
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'interactives-input',
  props: ['inputData'],
  components: {
    'text-input': __WEBPACK_IMPORTED_MODULE_0__components_TextInput__["a" /* default */],
    'textarea-input': __WEBPACK_IMPORTED_MODULE_1__components_TextareaInput__["a" /* default */],
    'dropdown': __WEBPACK_IMPORTED_MODULE_2__components_Dropdown__["a" /* default */],
    'check-input': __WEBPACK_IMPORTED_MODULE_3__components_CheckInput__["a" /* default */],
    'radio-input': __WEBPACK_IMPORTED_MODULE_4__components_RadioInput__["a" /* default */],
    'list-builder': __WEBPACK_IMPORTED_MODULE_5__components_ListBuilder__["a" /* default */]
  }
});

/***/ }),

/***/ "QOr7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TKMJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Upis":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("C4Xc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_26838f12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("i2BW");
function injectStyle (ssrContext) {
  __webpack_require__("TKMJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_26838f12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VSv+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'interactives-check-input',
  props: ['inputData'],
  data: function data() {
    return {
      value: []
    };
  },

  watch: {
    value: function value(newValue) {
      this.inputData.value = newValue;
    }
  }
});

/***/ }),

/***/ "VzdL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WBGR":
/***/ (function(module, exports) {

module.exports = [{"type":"check-input","label":"Which of the following services do you use? (Check all that apply.)","name":"main-services","value":[],"options":[{"label":"Email","name":"email"},{"label":"Facebook","name":"facebook"},{"label":"Twitter","name":"twitter"},{"label":"Amazon","name":"amazon"},{"label":"iTunes","name":"itunes"}]},{"type":"list-builder","label":"Enter any additional services here. (Type and hit Enter.)","name":"additional-services","placeholder":"Service name","value":[],"optional":true},{"type":"radio-input","label":"Would you like your executor to clear your web browsing history?","name":"browser-history","value":null,"options":[{"label":"Yes","name":"yes","value":true},{"label":"No","name":"no","value":false}]}]

/***/ }),

/***/ "WTS4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactives-check-input"},[_c('legend',[_vm._v(_vm._s(_vm.inputData.label))]),_vm._v(" "),_vm._l((_vm.inputData.options),function(option){return _c('div',{staticClass:"options"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"type":"checkbox","name":option.name},domProps:{"value":option.value !== undefined ? option.value : option.label,"checked":Array.isArray(_vm.value)?_vm._i(_vm.value,option.value !== undefined ? option.value : option.label)>-1:(_vm.value)},on:{"change":function($event){var $$a=_vm.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=option.value !== undefined ? option.value : option.label,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.value=$$a.concat([$$v]))}else{$$i>-1&&(_vm.value=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.value=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":option.name}},[_vm._v(_vm._s(option.label))])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cDoD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactives-radio-input"},[_c('legend',[_vm._v(_vm._s(_vm.inputData.label))]),_vm._v(" "),_vm._l((_vm.inputData.options),function(option){return _c('div',{staticClass:"options"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"type":"radio","name":option.name},domProps:{"value":option.value !== undefined ? option.value : option.label,"checked":_vm._q(_vm.value,option.value !== undefined ? option.value : option.label)},on:{"change":function($event){_vm.value=option.value !== undefined ? option.value : option.label}}}),_vm._v(" "),_c('label',{attrs:{"for":option.name}},[_vm._v(_vm._s(option.label))])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eueh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gvoR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WillInput_vue__ = __webpack_require__("0inR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e81f5d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WillInput_vue__ = __webpack_require__("34kq");
function injectStyle (ssrContext) {
  __webpack_require__("lVnM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WillInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e81f5d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WillInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i2BW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactives-form"},[_vm._l((_vm.formData),function(inputData){return _c('custom-input',{key:inputData.name,attrs:{"inputData":inputData}})}),_vm._v(" "),_c('div',{staticClass:"cont-btn-c"},[_c('button',{staticClass:"continue-button",attrs:{"disabled":!_vm.valid},on:{"click":_vm.submitFields}},[_vm._t("default",[_vm._v("Submit")])],2)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iH6H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_TextareaInput_vue__ = __webpack_require__("A9aO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5b85334_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_TextareaInput_vue__ = __webpack_require__("FEnh");
function injectStyle (ssrContext) {
  __webpack_require__("w0BJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_TextareaInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5b85334_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_TextareaInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l0+4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("OH0K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_58575be0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("KewI");
function injectStyle (ssrContext) {
  __webpack_require__("xSFL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_interactives_digital_will_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__interactives_digital_will_node_modules_vue_loader_lib_template_compiler_index_id_data_v_58575be0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_interactives_digital_will_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lVnM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p9/Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rNIx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactives-text-input"},[(_vm.inputData.label)?_c('label',{attrs:{"for":_vm.inputData.name}},[_vm._v(_vm._s(_vm.inputData.label))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"type":"text","name":_vm.inputData.name,"placeholder":_vm.inputData.placeholder},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tqyj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactives-list-builder"},[_c('div',{staticClass:"list-input"},[(_vm.inputData.label)?_c('label',{attrs:{"for":_vm.inputData.name}},[_vm._v(_vm._s(_vm.inputData.label))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newListItem),expression:"newListItem"}],attrs:{"type":"text","name":_vm.inputData.name,"placeholder":_vm.inputData.placeholder},domProps:{"value":(_vm.newListItem)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.addNewListItem($event)},"input":function($event){if($event.target.composing){ return; }_vm.newListItem=$event.target.value}}})]),_vm._v(" "),_c('ul',_vm._l((_vm.listItems),function(item,index){return _c("list-item",{key:item.id,tag:"li",attrs:{"itemContent":item.content},on:{"remove":_vm.removeListItem}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vMcm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactives-will-template"},[_c('button',{staticClass:"back-button",on:{"click":function($event){_vm.$emit('back')}}},[_vm._v("« Back")]),_vm._v(" "),_c('div',{staticClass:"will-output-body"},[_vm._m(0,false,false),_vm._v(" "),_c('p',[_vm._v("\n      I, "+_vm._s(_vm.templateData.userName.value)+" of "+_vm._s(_vm.templateData.userResidence.value)+", establish this as my digital will, laying out my preferences for the future use of my online accounts.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      I appoint "+_vm._s(_vm.templateData.execName.value)+" of "+_vm._s(_vm.templateData.execResidence.value)+" as the sole executor of this will.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Where appropriate and necessary, passwords and other login credentials will be provided to my executor via separate documentation.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      I give my executor the following duties and responsibilities:\n    ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formData[2].value),expression:"formData[2].value"}]},[_c('h3',[_vm._v("\n            Web browsing history\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            Delete the entire browsing history from all browsers on my computer.\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected('Email')),expression:"selected('Email')"}]},[_c('h3',[_vm._v("\n        Email\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        I employ "+_vm._s(_vm.templateData.email[0].value)+". Within 30 days of my death, I request that my executor access that account using the login credentials provided via supplementary documentation. They should then:\n        "),_c('ul',_vm._l((_vm.templateData.email[1].value),function(item){return _c('li',[_vm._v(_vm._s(item))])}))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected('Facebook')),expression:"selected('Facebook')"}]},[_c('h3',[_vm._v("\n            Facebook\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            I maintain a Facebook account under "+_vm._s(_vm.templateData.facebook[0].value)+". Within 30 days of my death, I request that my executor "+_vm._s(_vm.templateData.facebook[1].value)+".\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected('Twitter')),expression:"selected('Twitter')"}]},[_c('h3',[_vm._v("\n            Twitter\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          I maintain a Twitter account under "+_vm._s(_vm.templateData.twitter[0].value)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.templateData.twitter[0].value == 'the handle'),expression:"templateData.twitter[0].value == 'the handle'"}]},[_vm._v(" @"+_vm._s(_vm.templateData.twitter[1].value))]),_vm._v(". Within 30 days of my death, I request that my executor "+_vm._s(_vm.templateData.twitter[2].value)+".\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected('Amazon')),expression:"selected('Amazon')"}]},[_c('h3',[_vm._v("\n            Amazon\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            I maintain an Amazon account under "+_vm._s(_vm.templateData.amazon[0].value)+". Where allowed, I grant and transfer ongoing ownership of all e-books, digital movies, and music associated with that account to "+_vm._s(_vm.templateData.amazon[1].value)+". In addition, I request that my executor access my account and:\n            "),_c('ul',_vm._l((_vm.templateData.amazon[2].value),function(item){return _c('li',[_vm._v(_vm._s(item))])}))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected('iTunes')),expression:"selected('iTunes')"}]},[_c('h3',[_vm._v("\n            iTunes\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          I maintain an iTunes account under "+_vm._s(_vm.templateData.itunes[0].value)+". Where allowed, I grant and transfer ongoing ownership of all digital content associated with that account to "+_vm._s(_vm.templateData.itunes[1].value)+".\n          ")])]),_vm._v(" "),_vm._l((_vm.formData[1].value),function(service,index){return _c('div',[_c('h3',[_vm._v("\n              "+_vm._s(service)+"\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            I maintain an account with "+_vm._s(service)+" under the login "+_vm._s(_vm.templateData.additional[service][0].value)+". I request that my executor do the following with that account:\n            "),_c('ul',_vm._l((_vm.templateData.additional[service][1].value),function(item,index){return _c('li',[_vm._v(_vm._s(item === 'transfer' ? ("Transfer ownership of all associated digital media to " + (_vm.templateData.additional[service][2].value) + ".") : item))])})),_vm._v("\n            In addition, "+_vm._s(_vm.templateData.additional[service][3].value)+"\n          ")])])}),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('p',[_vm._v("__________________________")]),_vm._v(" "),_c('p',[_vm._v("__________________________")]),_vm._v(" "),_c('p',[_vm._v("__________________________")])],2),_vm._v(" "),_c('div',{staticClass:"cont-btn-c"},[_c('button',{staticClass:"print-button",on:{"click":_vm.print}},[_vm._v("Print")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"will-disclaimer"},[_c('em',[_vm._v("This document is "),_c('strong',[_vm._v("not legally binding or enforceable")]),_vm._v(".")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("I have signed my name")]),_vm._v(" on this the __________________________ (today’s date), declaring this is my digital will in the presence of the witnesses below.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w0BJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interactives_form_src_App__ = __webpack_require__("Upis");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_setupForm_json__ = __webpack_require__("WBGR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_setupForm_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_setupForm_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_WillInput__ = __webpack_require__("gvoR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_templateForm_json__ = __webpack_require__("D+Yd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_templateForm_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_templateForm_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_WillOutput__ = __webpack_require__("9wO9");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'interactives-digital-will',
  data: function data() {
    return {
      currentViewIndex: 0,
      views: ['will-setup', 'will-input', 'will-output'],
      formValidator: function formValidator(formData) {
        return !(formData[2].value === null | !formData[2].value & !formData[0].value.length & !formData[1].value.length);
      },
      setupForm: __WEBPACK_IMPORTED_MODULE_4__assets_setupForm_json___default.a,
      templateForm: __WEBPACK_IMPORTED_MODULE_6__assets_templateForm_json___default.a
    };
  },

  watch: {
    setupForm: {
      handler: function handler(newVal, oldVal) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(newVal[1].value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var service = _step.value;

            __WEBPACK_IMPORTED_MODULE_6__assets_templateForm_json___default.a.additional[service] = [{
              type: 'text-input',
              value: null,
              name: service + '-login',
              placeholder: 'your login'
            }, {
              type: 'check-input',
              value: null,
              label: '[Select all that apply:]',
              name: service + '-request',
              options: [{
                label: 'Establish a digital memorial.'
              }, {
                label: 'Message my regular correspondents with news of my death.'
              }, {
                label: 'Set up an auto reply for any future correspondents.'
              }, {
                label: 'Fulfill any outstanding transactions.'
              }, {
                label: 'Cancel any outstanding transactions.'
              }, {
                label: 'Cancel any outstanding transactions.'
              }, {
                label: 'Cancel any recurring payments.'
              }, {
                label: 'Remove payment options and other personal information from my account.'
              }, {
                label: 'Delete my search history.'
              }, {
                label: 'Transfer ownership of all associated digital media to the recipient specified below.',
                value: 'transfer'
              }, {
                label: 'Delete my account.'
              }]
            }, {
              type: 'text-input',
              label: 'Recipient of digital media [if applicable]:',
              value: null,
              name: service + '-recipient',
              placeholder: 'the recipient’s full legal name'
            }, {
              type: 'textarea-input',
              value: null,
              name: service + '-misc',
              placeholder: 'Write any additional requests here.'
            }];
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__assets_templateForm_json___default.a.additional)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var key = _step2.value;

            if (__WEBPACK_IMPORTED_MODULE_2_jquery__["inArray"](key, newVal[1].value) === -1) delete __WEBPACK_IMPORTED_MODULE_6__assets_templateForm_json___default.a.additional[key];
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      },
      deep: true
    }
  },
  computed: {
    currentView: function currentView() {
      return this.views[this.currentViewIndex];
    }
  },
  methods: {
    goForward: function goForward() {
      this.currentViewIndex++;
    },
    goBack: function goBack() {
      this.currentViewIndex--;
    },
    formSubmitted: function formSubmitted() {
      this.goForward();
    }
  },
  components: {
    'will-setup': __WEBPACK_IMPORTED_MODULE_3__interactives_form_src_App__["a" /* default */],
    'will-input': __WEBPACK_IMPORTED_MODULE_5__components_WillInput__["a" /* default */],
    'will-output': __WEBPACK_IMPORTED_MODULE_7__components_WillOutput__["a" /* default */]
  }
});

/***/ }),

/***/ "xSFL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yk1D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'interactives-dropdown-input',
  props: ['inputData'],
  data: function data() {
    return {
      value: null
    };
  },

  watch: {
    value: function value(newValue) {
      this.inputData.value = newValue;
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6b56f2f8d6a8afc20c9c.js